import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/clinical-solutions/ivd-clinical-performance-studies")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/ivd-clinical-performance-studies", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/clinical-solutions/estudios-de-rendimiento-clinico-de-ivd", replace: true });
  },
});
